module.exports = __webpack_public_path__ + "static/media/flight.6d90cac7.png";